import Splide from "@splidejs/splide";

/**
 * Insert a static CTA card ("Can't see your perfect role?") after the 2nd
 * vacancy card every time the AJAX plugin refreshes #vacancies.
 */
function initVacancyCTACard() {
  const container = document.getElementById("vacancies");
  if (!container || typeof vacancyCTA === "undefined") return;

  const ctaCardHTML = `
		<div class="card -vacancy -contact">
			<img src="${vacancyCTA.iconUrl}" alt="suitcase icon" />
			<div class="card__header">
				<h3 class="bm__h5">Can't see your perfect role?<br>Contact us</h3>
			</div>
			<div class="card__body">
				<p>Send us your message and CV and we'll get back to you</p>
				<div class="cta-ctnr">
					<a href="${vacancyCTA.contactUrl}" class="cta -plain -white">Let's connect</a>
				</div>
			</div>
		</div>`;

  function insertCTACard() {
    if (container.querySelector(".card.-contact")) return;

    const cards = container.querySelectorAll(".card.-vacancy:not(.-contact)");
    if (cards.length >= 2) {
      cards[1].insertAdjacentHTML("afterend", ctaCardHTML);
    } else if (cards.length > 0) {
      cards[cards.length - 1].insertAdjacentHTML("afterend", ctaCardHTML);
    }
  }

  const observer = new MutationObserver(function () {
    insertCTACard();
  });

  observer.observe(container, { childList: true });
}

document.addEventListener("DOMContentLoaded", function () {
  initVacancyCTACard();

  const blocks = document.querySelectorAll(".cards-block.-vacancy");

  if (!blocks.length) return;

  blocks.forEach(function (block) {
    const slider = block.querySelector(".vacancy-slider.splide");
    if (!slider) return;

    const splide = new Splide(slider, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      gap: "2.4rem",
      arrows: false,
      pagination: false,
      autoplay: false,
      mediaQuery: "min",
      breakpoints: {
        992: {
          perPage: 2,
        },
      },
    });

    splide.on("mounted move", function () {
      const prevBtn = block.querySelector(".vacancy-arrow.-prev");
      const nextBtn = block.querySelector(".vacancy-arrow.-next");

      if (prevBtn) {
        prevBtn.disabled = splide.index === 0;
      }
      if (nextBtn) {
        nextBtn.disabled =
          splide.index >= splide.Components.Controller.getEnd();
      }
    });

    splide.mount();

    const prevBtn = block.querySelector(".vacancy-arrow.-prev");
    const nextBtn = block.querySelector(".vacancy-arrow.-next");

    if (prevBtn && nextBtn) {
      prevBtn.addEventListener("click", function () {
        splide.go("<");
      });

      nextBtn.addEventListener("click", function () {
        splide.go(">");
      });
    }
  });
});
